import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "swiper-wrapper" }
const _hoisted_3 = { class: "c-image-text-card__inner" }
const _hoisted_4 = { class: "c-image-text-card__media" }

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { RichText, Text as JssText } from '@sitecore-jss/sitecore-jss-vue';
import { destroySwiper } from '@/utils/site-utils';
import { ImageTextCardProps } from '../../types/components/image-text-card';
import AdaptiveImage from '@/elements/AdaptiveImage.vue';
import 'swiper/css';
import utils from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageTextCard',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);
const items = computed(() => props.fields?.items ?? []);
const swiperEl = ref<HTMLElement | null>(null);
const paginationEl = ref<HTMLElement | null>(null);

let swiper: Swiper | null = null;

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-image-text-card'));

const rootStyle = computed(() => {
  return utils.overall.baseComStyle(props.fields);
});

const getItemLink = (item: (typeof items.value)[number]) => {
  const value = item.fields?.link?.value || {};
  return {
    href: value.href || '',
    target: value.target,
    label: value.text || value.title || item.fields?.title?.value || 'View details',
  };
};

const buildSwiper = () => {
  if (!swiperEl.value || !paginationEl.value || !items.value.length) return;

  destroySwiper(swiper, true, true);
  swiper = new Swiper(swiperEl.value, {
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    modules: [Pagination],
    pagination: {
      el: paginationEl.value,
      clickable: true,
      bulletElement: 'span',
    },
  });
};

onMounted(() => {
  setTimeout(() => nextTick(() => buildSwiper()), 50);
});

watch(
  () => items.value.length,
  (newLen, oldLen) => {
    if (newLen > 0 && newLen !== oldLen) {
      nextTick(() => buildSwiper());
    }
  }
);

onBeforeUnmount(() => {
  destroySwiper(swiper, true, true);
});

return (_ctx: any,_cache: any) => {
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: __props.rendering?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "swiper c-image-text-card__swiper",
              ref_key: "swiperEl",
              ref: swiperEl
            }, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id || index,
                    class: "swiper-slide c-image-text-card__slide"
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        (item.fields?.image)
                          ? (_openBlock(), _createBlock(AdaptiveImage, {
                              key: 0,
                              class: "c-image-text-card__image",
                              field: item.fields.image,
                              show: true,
                              "enable-scroll-detection": false,
                              "show-image-redius": false
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(), _createBlock(_resolveDynamicComponent(getItemLink(item).href ? 'a' : 'div'), {
                        class: "c-image-text-card__content",
                        href: getItemLink(item).href || undefined,
                        target: getItemLink(item).target,
                        rel: getItemLink(item).target === '_blank' ? 'noopener noreferrer' : undefined,
                        "aria-label": getItemLink(item).href ? getItemLink(item).label : undefined
                      }, {
                        default: _withCtx(() => [
                          (item.fields?.title?.value)
                            ? (_openBlock(), _createBlock(_unref(JssText), {
                                key: 0,
                                class: "c-image-text-card__title",
                                field: item.fields.title
                              }, null, 8, ["field"]))
                            : _createCommentVNode("", true),
                          (item.fields?.description?.value)
                            ? (_openBlock(), _createBlock(_unref(RichText), {
                                key: 1,
                                class: "c-image-text-card__description",
                                field: item.fields.description
                              }, null, 8, ["field"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["href", "target", "rel", "aria-label"]))
                    ])
                  ]))
                }), 128))
              ])
            ], 512),
            _withDirectives(_createElementVNode("div", {
              class: "c-image-text-card__pagination swiper-pagination",
              ref_key: "paginationEl",
              ref: paginationEl
            }, null, 512), [
              [_vShow, items.value.length > 1]
            ])
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})